/**
 * Where the community heatmap's raster tiles live.
 *
 * Shared by the web map overlay (BaseMapDialogHelpers) and the print page
 * preview, so the screen and the paper can never point at different
 * tilesets. The print renderer reads the same URL from
 * PrintMaps::DocumentPresenter::HEATMAP_TILE_URL.
 */
export const HEATMAP_TILE_URL = 'https://heatmap.hiiker.com/{z}/{x}/{y}.png';
export const HEATMAP_TILE_SIZE = 512;
/** Native resolution of the tileset; Mapbox overzooms past it. */
export const HEATMAP_NATIVE_MAXZOOM = 15;
